import {
  Avatar,
  Badge,
  TableBody,
  TableCell,
  TableRow,
} from "@windmill/react-ui";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState, useEffect } from 'react'
import HistoryServices from "services/HistoryServices";
//internal import  
import { format } from 'date-fns';

const HistoryTable2 = ({ data, isCheck, setIsCheck, currency, lang, isLoading, setIsLoading, history }) => {
  const {
    handleModalOpen,
    serviceId,
    handleUpdate,
    // Destructurer d'autres valeurs ou fonctions nécessaires depuis useToggleDrawer si besoin 
  } = useToggleDrawer();
  return (
    <>


      <TableBody>
        {data?.map((item, i) => (
          <TableRow key={i + 1}>
            {/* <TableCell>
              <div className="flex items-center">
            
                
                  <h2 className="text-sm font-medium">
                    {item.id}
                  </h2>
              </div>

            </TableCell> */}

            <TableCell style={{ maxWidth: '5ch', overflow: 'break-word', whiteSpace: 'normal' }}>
              <b>
                {item.admin.name}
              </b>
            </TableCell>
            <TableCell>
              <span className="text-sm" style={{ maxWidth: '22ch', overflow: 'break-word', whiteSpace: 'normal' }}>
                {item.action}
              </span>
            </TableCell>

            <TableCell>
              <span className="text-sm">
                {format(new Date(item.created_at), 'dd MMM yyyy')}
                <div>{format(new Date(item.created_at), "HH:mm")}</div>
              </span>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default HistoryTable2;
